// extracted by mini-css-extract-plugin
export default {"sort":"UR-z","sortSelect":"VR-z","disabled":"WR-z"};